import React, { useCallback, useState, useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { toast } from "react-toastify";
import { FaArrowLeft } from 'react-icons/fa';
import * as Yup from 'yup';

import NativeSelect from '../../../../components/NativeSelect';
import Input from '../../../../components/Input';
import Textarea from '../../../../components/Textarea';
import Loader from '../../../../components/Loader';

import getValidationErrors from '../../../../utils/getValidationErrors';
import selectGoal from '../../../../utils/selectGoal';

import api from '../../../../services/api';

import { Container, Form } from './styles';

const AddMission = () => {
  const history = useHistory();
  const [modalLoading, setModalLoading] = useState(false);
  const [whichGoal, setwitchGoal] = useState("");
  const formRef = useRef(null);
  const token = localStorage.getItem("@Ocariot:token");

  const createNewMission = useCallback(async (data) => {
    try {
      formRef.current?.setErrors({});
      const schema = Yup.object().shape({
        missionDetails: Yup.object().shape({
          title: Yup.string().required('Título neceśsário'),
          skill: Yup.string().required('Habilidade neceśsária'),
          duration: Yup.string().required('Duração neceśsária'),
          score: Yup.string().required('Pont. necessária'),
          description: Yup.string().required('Descrição necessária'),
          recommendationParent: Yup.string().required('Recomendação ao familiar necessária'),
          recommendationChild: Yup.string().required('Recomendação à criança necessária'),
        }),
        type: Yup.string().required('Tipo neceśsário'),
        goals: Yup.object().shape({
          generalGoal: Yup.string(),
          steps: Yup.string(),
          caloriesOut: Yup.string(),
          activeMinutes: Yup.string(),
          sedentaryMinutes: Yup.string(),
          wakeMinutes: Yup.string(),
          awakeMinutes: Yup.string(),
          remMinutes: Yup.string(),
          lightMinutes: Yup.string(),
          deepMinutes: Yup.string(),

        }),
      });

      await schema.validate(data, { abortEarly: false });
      setModalLoading(true);

      const { missionDetails, goals} = data;

      await api.post('mission', {missionDetails, goals}, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setModalLoading(false);
      history.push('/missions')
      toast.success('Missão criada com sucesso!');

    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err)
        formRef.current?.setErrors(errors);
        return;
      }
      console.log(err);
      toast.error('Falha ao criar nova missão. Por favor tente novamente');
    }
  }, []);
  return (
    <Container>
      <Link to="/missions">
        <FaArrowLeft />
        Voltar para missões
      </Link>
      <h2>Adicionar nova missão</h2>
      <Form className="add-mission" ref={formRef} onSubmit={createNewMission}>
        <div className="body-form">
          <div className="mission-info">
            <h4>Informações gerais</h4>
            <div className="input-div">
              <label>Título</label>
              <Input type="text" name="missionDetails.title" />
            </div>
            <div className="input-div">
              <label>Habilidade</label>
              <NativeSelect type="text" name="missionDetails.skill">
                <option value="" hidden>Selecione uma habilidade</option>
                <option value="Destreza">Destreza</option>
                <option value="Disciplina">Disciplina</option>
                <option value="Inteligência">Inteligência</option>
              </NativeSelect>
            </div>
            <div className="small-inputs">
              <div className="input-div">
                <label>Pontuação</label>
                <Input type="text" name="missionDetails.score" />
              </div>
              <div className="input-div">
                <label>Duração (dias)</label>
                <Input  name="missionDetails.duration"/>
              </div>
            </div>
            <div className="input-div">
              <label>Descrição</label>
              <Textarea type="text" name="missionDetails.description" />
            </div>
          </div>
          <div className="mission-info">
            <h4>Objetivo</h4>
            <div className="input-div">
              <p style={{ fontSize: '.8rem', margin: '.2rem 0' }}>Selecione um tipo de objetivo </p>
              <NativeSelect type="text" name="type" onChange={(e) => setwitchGoal(e.target.value)}>
                <option value="" hidden>Tipos de objetivo</option>
                <option value="goals.generalGoal">Objetivo genérico</option>
                <option value="goals.steps">Quantidade de passos</option>
                <option value="goals.caloriesOut">Quantidade de calorias gastas</option>
                <option value="goals.activeMinutes">Quantidade de horas ativas</option>
                <option value="goals.sedentaryMinutes">Quantidade de horas sedentárias</option>
                <option value="goals.wakeMinutes">Quantidade de tempo acordado</option>
                <option value="goals.awakeMinutes">Quantidade de horas sem sono</option>
                <option value="goals.remMinutes">Quantidade de horas de sono REM</option>
                <option value="goals.lightMinutes">Quantidade de horas com sono leve</option>
                <option value="goals.deepMinutes">Quantidade de horas com sono profundo</option>
              </NativeSelect>
            </div>
            {whichGoal !== "" && (
              (whichGoal === "goals.generalGoal") ? (
                <div className="input-div">
                  <label>{selectGoal(whichGoal)}</label>
                  <Textarea name={whichGoal} />
                </div>

              ) : (
                <div className="input-div">
                  <label>{selectGoal(whichGoal)}</label>
                  <Input name={whichGoal} />
                </div>
              )
            )}
          </div>

          <div className="mission-info">
            <h4>Recomendações</h4>
            <div className="input-div">
              <label>Recomendação ao pai</label>
              <Textarea type="text" name="missionDetails.recommendationParent" />
            </div>
            <div className="input-div">
              <label>Recomendação à criança</label>
              <Textarea type="text" name="missionDetails.recommendationChild" />
            </div>
          </div>
        </div>
        <div className="button-div">
          <button className="submit-button" type="submit">
            {modalLoading ? <Loader color = 'white'/> : 'Adicionar'}
          </button>
        </div>
      </Form >
    </Container >
  );
}

export default AddMission;